import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { ExchangeRateRefDateMappingProvider } from "presentation/store/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { ExchangeRateRefDateMappingMasterView } from "presentation/view/section/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingMasterView";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const ExchangeRateRefDateMappingContMain = () => {
    return <ANAInfoWrapper permission={Permission.EXCHANGE_RATE_REF_DATE_MAPPING_MAINTENANCE}>
        <MessageBarWrapper>
            <ExchangeRateRefDateMappingProvider>
                <GridStyles/>
                <ExchangeRateRefDateMappingMasterView/>
            </ExchangeRateRefDateMappingProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default ExchangeRateRefDateMappingContMain;